import React, { useState } from "react";

export default function LocationForNotSignIN({
  onClose,
  updateLocation,
  detectLocation,
  setAuthOpen,
  setOpen
}) {
  const [pincode, setPincode] = useState("");

  const handleApply = () => {
    if (!pincode.trim()) return;
    updateLocation(pincode);
    onClose();
  };
const handleCurrentLocation = () => {
        detectLocation();
        onClose();
    };

    return (
        <>
            <div className="flex items-center justify-between px-5 py-3 border-b">
                <h2 className="font-semibold">
                    Choose your location
                </h2>

                <button
                    onClick={onClose}
                    className="text-2xl cursor-pointer"
                >
                    ×
                </button>
            </div>

            <div className="p-6">
                <p className="text-gray-600 text-xs mb-5">
                    Select a delivery location to see product
                    availability and delivery options
                </p>

                <button
                    className="
                        w-full bg-yellow-400
                        py-2 rounded-full
                        font-medium mb-4 text-xs cursor-pointer
                    "
                                onClick={() => {
                                    setAuthOpen(true)
                                    setOpen(false)
                                }}
                >
                    Sign in to see your addresses
                </button>

                <div className="text-center text-gray-500 mb-4 text-xs">
                    or enter an Indian pincode
                </div>

                <div className="flex gap-3 mb-4 text-xs">
                    <input
                        type="text"
                        value={pincode}
                        onChange={(e) =>
                            setPincode(e.target.value)
                        }
                        placeholder="Enter pincode"
                        className="
                            flex-1 border border-gray-300 rounded-md
                            px-2 py-2
                        "
                    />

                    <button
                        onClick={handleApply}
                        className="
                            px-8 border border-gray-300 rounded-full
                            font-medium cursor-pointer
                        "
                    >
                        Apply
                    </button>
                </div>

                <button
                    onClick={handleCurrentLocation}
                    className="
                        text-blue-600
                        hover:underline
                        text-sm cursor-pointer
                    "
                >
                    Use my current location
                </button>
            </div>
        </>
    );
}